const fr = {
  nav: {
    dashboard: "Tableau de bord",
    messages: "Messagerie",
    calls: "Appels",
    calendar: "Calendrier",
    automations: "Automatisations",
    marketing: "Marketing",
    orders: "Commandes",
    customers: "Clients",
    analytics: "Analytiques",
    settings: "Paramètres",
    integrations: "Intégrations",
    notifications: "Notifications",
    logout: "Déconnexion",
    products: "Produits",
    tasks: "Tâches",
    billing: "Facturation",
    support: "Support",
    myBusiness: "Mon entreprise",
    restaurantEditor: "Éditeur Restaurant",
    liveRoom: "Salle en direct",
    myProfile: "Mon profil",
    team: "Équipe",
    help: "Aide",
    ai: "Assistant IA",
    logs: "Logs",
    alerts: "Alertes",
    whatsapp: "WhatsApp",
  },

  common: {
    loading: "Chargement...",
    save: "Enregistrer",
    saving: "Enregistrement...",
    saved: "Enregistré",
    error: "Erreur",
    openNavigation: "Ouvrir la navigation",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    search: "Rechercher",
    filter: "Filtrer",
    actions: "Actions",
    status: "Statut",
    type: "Type",
    name: "Nom",
    email: "E-mail",
    phone: "Téléphone",
    date: "Date",
    total: "Total",
    empty: "Aucun résultat",
    perPage: "Par page",
    purchases: "Achats",
    whatsapp: "WhatsApp",
    noData: "Pas de données",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    yes: "Oui",
    no: "Non",
    confirm: "Confirmer",
    close: "Fermer",
    open: "Ouvrir",
    add: "Ajouter",
    remove: "Retirer",
    update: "Mettre à jour",
    creating: "Création...",
    updating: "Mise à jour...",
    deleting: "Suppression...",
    created: "Créé",
    updated: "Mis à jour",
    deleted: "Supprimé",
    viewAll: "Voir tout",
    manage: "Gérer",
    all: "Tous",
    manual: "Manuel",
    bookings: "Réservations",
    booking: "Réservation",
    of: "de",
    page: "Page",
    noResults: "Aucun résultat",
    view: "Voir",
    online: "En ligne",
    offline: "Hors ligne",
    origin: "Origine",
    optional: "optionnel",
    create: "Créer",
    select: "Sélectionner",
    filters: "Filtres",
  },

  topbar: {
    client: "Client",
    profile: "Profil",
    logout: "Se déconnecter",
    defaultClient: "Par défaut",
  },

  status: {
    online: "En ligne",
    offline: "Hors ligne",
    pending: "En attente",
    completed: "Terminé",
    cancelled: "Annulé",
    processing: "En cours",
    shipped: "Expédié",
    delivered: "Livré",
    refunded: "Remboursé",
    confirmed: "Confirmé",
    paid: "Payé",
    onHold: "En attente",
    failed: "Échoué",
    pendingArrival: "En route 🟠",
    checkedIn: "Check-in",
    inHouse: "Sur place",
    checkedOut: "Check-out",
    noShow: "No Show",
  },

  time: {
    now: "Maintenant",
    minutesAgo: "Il y a {{count}}m",
    hoursAgo: "Il y a {{count}}h",
    daysAgo: "Il y a {{count}}d",
    minutes_short: "m",
    hours_short: "h",
    days_short: "d",
  },

  customers: {
    title: "Clients",
    subtitle: "Clients WhatsApp, boutique en ligne et ajoutés manuellement",
    detail: "Détails du client",
    newCustomer: "Nouveau client",
    editCustomer: "Modifier le client",
    backToCustomers: "Retour aux clients",
    createOffer: "Créer une offre",
    deleteTitle: "Supprimer le client ?",
    deleteConfirm: "Le client {{name}} sera supprimé. Cette action est irréversible.",
    thisCustomer: "ce client",
    noName: "Sans nom",
    searchPlaceholder: "Nom, e-mail ou téléphone...",
    noResultsWithFilters: "Aucun client trouvé avec les filtres appliqués",
    totalSpent: "Total dépensé",
    segments: {
      all: "Tous les segments",
      new: "Nouveaux (≤1 commande)",
      recurring: "Récurrents (≥2)",
      inactive: "Inactifs (+60d)",
      topSpenders: "Gros dépensiers",
      topOrders: "Plus de commandes",
      recent: "Plus récents",
    },
    table: {
      name: "Nom",
      customer: "Client",
      contact: "Contact",
      totalSpent: "Total dépensé",
      orders: "Commandes",
      lastActivity: "Dernière activité",
      actions: "Actions",
      origin: "Origine",
    },
    contactMissing: "Pas de coordonnées",
    empty: "Aucun client",
    noBookings: "Sans réservations",
    perPage: "Par page",
    filters: {
      channel: "Canal",
      date: "Date",
    },
    details: {
      contactInfo: "Informations de contact",
      orderHistory: "Historique des commandes",
      notes: "Notes",
      totalSpent: "Total dépensé",
      lifetimeValue: "Valeur à vie",
      averageOrder: "Commande moyenne",
      averageTicket: "Ticket moyen",
      firstOrder: "Première commande",
      lastOrder: "Dernière commande",
      lastMessage: "Dernier message",
      registered: "Inscrit",
      recentActivity: "Activité récente",
      ordersOrBookings: "Commandes/Réservations",
      viewAllOrders: "Voir toutes les commandes",
      note: "Note",
      tags: "Étiquettes",
    },
    placeholders: {
      name: "Mohamed Alami",
      email: "client@email.com",
      phone: "+212 6XX XXX XXX",
      notes: "Notes sur ce client...",
      addTag: "Ajouter une étiquette…",
      writeNote: "Écrire une note…",
    },
    errors: {
      atLeastOneField: "Ajoutez au moins un nom, un e-mail ou un téléphone",
    },
  },

  orders: {
    title: "Commandes",
    detail: "Détails de la commande",
    unifiedDescription: "Liste unifiée — WooCommerce, Shopify et PrestaShop.",
    searchPlaceholder: "Rechercher #commande, client, e-mail...",
    ordersCount: "commandes",
    showing: "Affichage de",
    loadingDetail: "Chargement des détails...",
    reminder: "Rappel",
    return: "Retour",
    returnType: "Retour",
    exchangeType: "Échange",
    createRequest: "Créer une demande",
    reminderWhat: "Que faut-il faire ?",
    reminderPlaceholder: "Ex : Envoyer la commande la semaine prochaine",
    reasonPlaceholder: "Décrivez le motif du retour ou de l'échange...",
    notFound: "Commande non trouvée",
    table: {
      order: "Commande",
      date: "Date",
      customer: "Client",
      total: "Total",
      status: "Statut",
      items: "Articles",
      origin: "Origine",
      actions: "Actions",
      view: "Voir",
    },
    empty: "Aucune commande",
    perPage: "Par page",
    shipping: "Expédition",
    refundRequest: "Demande de retour / échange",
    internalNotes: "Notes internes",
    newReminder: "Nouveau rappel",
    reminderDateTime: "Date / heure (optionnel)",
    reason: "Motif",
    history: "Historique",
    purchases: "Achats",
    totalSpent: "Total dépensé",
    nameAZ: "Nom A-Z",
    filters: {
      allOrders: "Toutes les commandes",
      pending: "En attente",
      processing: "En cours",
      completed: "Terminées",
      cancelled: "Annulées",
      dateRange: "Période",
    },
    details: {
      orderInfo: "Informations sur la commande",
      customerInfo: "Informations client",
      items: "Articles",
      shippingAddress: "Adresse de livraison",
      billingAddress: "Adresse de facturation",
      paymentMethod: "Mode de paiement",
      shippingMethod: "Mode de livraison",
      subtotal: "Sous-total",
      shippingCost: "Frais de port",
      taxes: "Taxes",
      discount: "Remise",
      total: "Total",
    },
    errors: {
      cannotSaveStatus: "Impossible d'enregistrer le statut",
      cannotSaveReminder: "Erreur lors de l'enregistrement du rappel",
      cannotCreateReturn: "Erreur lors de la création de la demande",
    },
  },

  dashboard: {
    title: "Tableau de bord",
    subtitle: "Aperçu en temps réel de votre activité",
    whatsappMessages: "Messages WhatsApp",
    totalCustomers: "Total clients",
    recentMessages: "Messages récents",
    latestOrders: "Dernières commandes",
    latestBookings: "Dernières réservations",
    activity: "Activité",
    messages: "Messages",
    runs: "Exécutions",
    success: "Succès",
    contacts: "contacts",
    new: "nouveaux",
    people: "personnes",
    upcoming: "À venir",
    appointments: "Rendez-vous",
    bookings: "Réservations",
    patients: "Patients",
    newThisPeriod: "nouveaux cette période",
    noRecentMessages: "Aucun message récent",
    noRecentOrders: "Aucune commande récente",
    noRecentBookings: "Aucune réservation récente",
    noText: "(pas de texte)",
    createFirstAutomation: "Créer une automatisation →",
    last7Days: "7 jours",
    last30Days: "30 jours",
    nucleo: "Noyau",
    dispatches: "Envois",
    totalProcessedEvents: "Total des événements traités",
    successfulDispatches: "Envois réussis",
    matchedStatusDesc: "Envois avec le statut 'matched'",
    failedDispatches: "Envois échoués",
    errorStatusDesc: "Envois avec le statut 'error'",
    skippedDispatches: "Omis / Doublons",
    skippedStatusDesc: "Envois avec le statut 'skipped'",
    operationalMonitoring: "Suivi Opérationnel",
    noRecentEvents: "Aucun événement récent.",
    aiTrigger: "Déclencheur IA",
    regexFallback: "Repli Regex",
    event: "Événement",
  },

  marketing: {
    newCampaign: "Nouvelle campagne",
    email: "E-mail",
    sms: "SMS",
    whatsapp: "WhatsApp",
    social: "Réseaux sociaux",
    scheduled: "Programmé",
    sent: "Envoyé",
    subtitle: "Modèles et campagnes pour {{name}}",
    yourBusiness: "votre entreprise",
    newTemplate: "Nouveau modèle",
    editTemplate: "Modifier le modèle",
    createTemplate: "Créer un modèle",
    templateUpdated: "Modèle mis à jour",
    templateCreated: "Modèle créé",
    templateDeleted: "Modèle supprimé",
    errorDeleting: "Erreur lors de la suppression",
    confirmDelete: "Supprimer ce modèle ?",
    varsHint: "Les variables sont détectées automatiquement avec {{variable}}",
    templateName: "Nom du modèle",
    subject: "Objet",
    message: "Message",
    characters: "caractères",
    detectedVars: "Variables détectées",
    variableLabel: "Étiquette",
    allowReplies: "Autoriser les réponses des clients",
    launchCampaign: "Lancer la campagne",
    campaignName: "Nom de la campagne",
    audienceSegment: "Segment d'audience",
    templateVars: "Variables du modèle",
    preview: "Aperçu",
    scheduleSend: "Planifier l'envoi",
    reach: "Portée est.",
    sendType: "Envoi",
    immediate: "Immédiat",
    replies: "Réponses",
    allowed: "Autorisées",
    disabled: "Désactivées",
    schedule: "Planifier",
    sendNow: "Envoyer maintenant",
    yours: "Le vôtre",
    campaignLaunched: "Campagne lancée auprès de ~{{count}} contacts",
    searchPlaceholder: "Rechercher des modèles...",
    templates: "modèles",
    template: "modèle",
    loading: "Chargement des modèles...",
    yourTemplates: "Vos modèles",
    new: "Nouveau",
    noOwnTemplates: "Aucun modèle personnel",
    createFirstHint: "Créez votre premier modèle personnalisé",
    zepelinTemplates: "Modèles Zepelin",
    available: "disponibles",
    zepelinTemplatesDesc: "Modèles professionnels créés par l'équipe Zepelin. Mis à jour avec les nouveaux événements et tendances. Lecture seule — utilisez-les directement ou comme base pour les vôtres.",
    segments: {
      all: "Tous les contacts",
      allDesc: "Base CRM complète",
      recent30: "30 derniers jours",
      recent30Desc: "Contacts créés récemment",
      recent90: "90 derniers jours",
      recent90Desc: "Clients du trimestre",
      withBookings: "Avec réservations",
      withBookingsDesc: "Ont effectué au moins une réservation",
      noShow: "No-shows",
      noShowDesc: "Ne se sont pas présentés à leur réservation",
      vip: "VIP (3+ réservations)",
      vipDesc: "Clients fréquents",
    },
    placeholders: {
      emailBody: "Bonjour {{nombre}},\n\nNous espérons que vous allez bien...",
      whatsappBody: "Bonjour {{nombre}}, nous vous rappelons votre réservation pour demain à {{hora}}...",
      templateName: "Ex : Rappel réservation dîner",
      subject: "Objet de l'e-mail",
    },
    stats: {
      total: "Total contacts",
      withEmail: "Avec e-mail",
      withPhone: "Avec téléphone",
      new30d: "Nouveaux 30j",
    },
  },

  analytics: {
    title: "Analytiques",
    overview: "Aperçu",
    revenue: "Chiffre d'affaires",
    today: "Aujourd'hui",
    yesterday: "Hier",
    noChange: "Pas de changement",
    vsPrevious: "par rapport à la période précédente",
    noDataPeriod: "Pas de données sur cette période",
    last7Days: "7 derniers jours",
    last30Days: "30 derniers jours",
    updating: "Mise à jour...",
    updatedAt: "Mis à jour à {{time}}",
    loading: "Chargement...",
    "7days": "7 jours",
    "30days": "30 jours",
    totalMessages: "Messages totaux",
    messagesSummary: "{{in}} reçus · {{out}} envoyés",
    conversations: "Conversations",
    uniqueThreads: "Fils uniques",
    newContacts: "Nouveaux contacts",
    crmTotal: "{{count}} au total dans le CRM",
    confirmedBookings: "Réservations confirmées",
    bookingsSummary: "{{cancelled}} annulées · {{pending}} en attente",
    messageActivity: "Activité des messages",
    sent: "Envoyés",
    received: "Reçus",
    templates: "Modèles",
    failed: "Échoués",
    estimatedCost: "Coût estimé",
    contactBase: "Base de contacts",
    withEmail: "Avec e-mail",
    withPhone: "Avec téléphone",
    newThisWeek: "Nouveaux cette semaine",
    totalCrm: "Total CRM",
    activePlan: "Plan actif",
    month: "mois",
    noActiveSubscription: "Aucun abonnement actif",
    voiceBalance: "Solde voix",
    min: "min",
    smsBalance: "Solde SMS",
    campaigns: "Campagnes",
    messagingChannels: "Canaux de messagerie",
    bookingStatus: "Statut des réservations",
    noBookings: "Aucune réservation enregistrée",
    totalHistory: "Total historique",
  },

  calendar: {
    title: "Calendrier",
    loading: "Chargement du calendrier...",
    personalAgenda: "Agenda personnel",
    stayManagement: "Gestion des séjours",
    consultationManagement: "Gestion des consultations",
    appointmentManagement: "Gestion des rendez-vous",
    bookingManagement: "Gestion des réservations",
    weekOf: "Semaine du",
    more: "plus",
    appointmentsThisWeek: "rendez-vous cette semaine",
    newAppointment: "Nouveau rendez-vous",
    today: "Aujourd'hui",
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    agenda: "Agenda",
    events: "Événements",
    newEvent: "Nouvel événement",
    editEvent: "Modifier l'événement",
    deleteEvent: "Supprimer l'événement",
    eventDetails: "Détails de l'événement",
    allDay: "Toute la journée",
    starts: "Commence le",
    ends: "Se termine le",
    repeat: "Répéter",
    location: "Lieu",
    description: "Description",
    attendees: "Participants",
    addAttendee: "Ajouter un participant",
    reminders: "Rappels",
    previous: "Précédent",
    next: "Suivant",
    hour: "Heure",
    addEvent: "Ajouter {{event}}",
    checkin: "Check-in",
    checkout: "Check-out",
    inHouse: "Sur place",
    roomMap: "Plan des chambres",
    freeRoom: "Chambre libre",
    bookedVia: "Réservé via",
    createdOn: "Créé le",
    deletePermanently: "Supprimer définitivement",
    selectedDay: "Jour sélectionné",
    allStatuses: "Tous les statuts",
    active: "Actifs",
    cancelledNoShow: "Annulés / No show",
    exportCsv: "Exporter CSV",
    new: "Nouveau",
    ofTheDay: "du jour",
    clickForDetails: "cliquer pour voir les détails",
    noEventsForDay: "Aucun {{event}} pour ce jour",
    tablePlaceholder: "Ex : 2 → Table 2",
    startTime: "Heure de début",
    endTime: "Heure de fin",
    duration: "Durée",
    professional: "Professionnel",
    professionalPlaceholder: "Nom du professionnel",
    service: "Service",
    servicePlaceholder: "Manucure, Massage...",
    department: "Département",
    departmentPlaceholder: "Cardiologie...",
    doctor: "Médecin",
    doctorPlaceholder: "Dr. Nom",
    patientName: "Nom du patient",
    patientPlaceholder: "Jean Dupont",
    clientName: "Nom du client",
    clientPlaceholder: "Marie Durant",
    guestName: "Nom de l'invité",
    guestPlaceholder: "Famille Bensouda",
    bookingName: "Nom de la réservation",
    bookingPlaceholder: "Réservation anniversaire",
    editAppointment: "Modifier le rendez-vous",
    titleSubject: "Titre / Objet",
    titlePlaceholder: "Ex : Réunion client, Conseil...",
    notesPlaceholder: "Tout détail pertinent...",
    hours: "heures",
    appointment: "rendez-vous",
    room: "Ch.",
    guests: "invités",
    pax: "Pax",
    tableRoom: "Table/Chambre",
    start: "Début",
    end: "Fin",
    title: "Titre",
    bookingHistory: "Historique des réservations",
    noBookingsRegistered: "Aucune réservation enregistrée",
    paxShort: "pers.",
    table: "Table",
  },

  messages: {
    title: "Messages",
    threads: "Fils",
    noThreads: "Aucune conversation",
    noSubject: "(sans objet)",
    selectThread: "Sélectionnez un fil",
    noMessages: "Aucun message",
    you: "moi",
    contact: "contact",
    typeMessage: "Écrivez un message...",
    send: "Envoyer",
    sending: "Envoi en cours...",
    inbox: "Boîte de réception",
    sent: "Envoyés",
    drafts: "Brouillons",
    archived: "Archivés",
    spam: "Spam",
    trash: "Corbeille",
    compose: "Rédiger",
    reply: "Répondre",
    forward: "Transférer",
    delete: "Supprimer",
    markAsRead: "Marquer comme lu",
    markAsUnread: "Marquer comme non lu",
    archive: "Archiver",
    search: "Rechercher des messages...",
    selectConversation: "Sélectionnez une conversation",
    attachments: "Pièces jointes",
    messageSent: "Message envoyé",
    messageFailed: "Erreur lors de l'envoi",
    sendMessage: "Envoyer un message",
    sendTemplate: "Envoyer un modèle",
    previews: {
      noMessages: "Pas de messages r\u00e9cents",
      audio: "Audio",
      image: "Image",
      video: "Vid\u00e9o",
      location: "Emplacement",
      document: "Document",
      template: "Mod\u00e8le",
    },
    header: {
      aiPaused: "🤖 IA en pause — mode manuel activé",
      aiReactivated: "🤖 IA réactivée",
      aiError: "Erreur lors du changement d'état de l'IA",
      resolved: "Résolue",
      reopened: "Réouverte",
      archived: "Archivée",
      unarchived: "Désarchivée",
      addedFromInbox: "Ajouté depuis la boîte de réception",
      contactSaved: "Contact enregistré",
      saveError: "Erreur lors de l'enregistrement",
      addContact: "Ajouter un contact",
      editContact: "Modifier le contact",
      contactNamePlaceholder: "Nom du contact",
      saveContact: "Enregistrer le contact",
      conversation: "Conversation",
      reopen: "Réouvrir",
      resolve: "Résoudre",
      unarchive: "Désarchiver",
      archive: "Archiver",
      pauseAiHint: "Mettre l'IA en pause et répondre manuellement",
      pauseAi: "Pause IA",
      activateAiHint: "Réactiver l'IA",
      activateAi: "Activer IA",
      closeConversation: "Fermer la conversation",
    },
    input: {
      addDescription: "Ajouter une description...",
      fileTooLarge: "est trop volumineux",
      attachError: "Erreur lors de l'ajout du fichier",
      sendError: "Erreur lors de l'envoi",
      placeholder: "Écrivez un message...",
    },
    templates: {
      title: "Envoyer un modèle WhatsApp",
      loading: "Chargement des modèles...",
      none: "Aucun modèle approuvé",
      select: "Sélectionnez un modèle",
      variables: "variables",
      change: "Changer de modèle",
      variable: "Variable",
      valueFor: "Valeur pour",
      preview: "Aperçu",
      sent: "Modèle envoyé",
      sendError: "Erreur lors de l'envoi du modèle",
    },
    location: {
      title: "Envoyer l'emplacement",
      searchPlaceholder: "Rechercher un lieu...",
      useCurrent: "Utiliser ma position actuelle",
      gettingLocation: "Obtention de la position...",
      searchError: "Erreur lors de la recherche de l'emplacement",
      geoNotAvailable: "Géolocalisation non disponible",
      geoError: "Impossible d'obtenir la position",
      sent: "Emplacement envoyé",
      sendError: "Erreur lors de l'envoi de l'emplacement",
      change: "← Changer d'emplacement",
      map: "Carte",
      mapNotAvailable: "Carte non disponible",
      viewOnMaps: "Voir sur Google Maps",
    },
    bubbles: {
      download: "Télécharger",
      tapToDownload: "Appuyez pour télécharger",
      retry: "Réessayer",
      sharedLocation: "Emplacement partagé",
      whatsappTemplate: "Modèle WhatsApp",
    },
    voice: {
      error: "Impossible d'accéder au micro",
      recording: "Enregistrement...",
      label: "Enregistrer un message vocal",
    }
  },

  integrations: {
    title: "Intégrations",
    subtitle: "Connectez vos outils préférés et automatisez vos flux de travail",
    loadingAccount: "Récupération des informations du compte",
    noActiveSession: "Pas de session active",
    noTenantFound: "Aucun tenant valide trouvé. Veuillez vous reconnecter.",
    goToLogin: "Aller à la connexion",
    activeTenant: "Tenant actif",
    connected: "Connectées",
    syncing: "Synchronisation",
    failed: "Échouées",
    searchPlaceholder: "Rechercher une intégration...",
    noIntegrationsFound: "Aucune intégration trouvée",
    tryDifferentSearch: "Essayez d'autres termes ou sélectionnez une autre catégorie",
    noIntegrationsAvailable: "Aucune intégration disponible pour le moment",
    disconnect: "Déconnecter",
    disconnectConfirm: "Voulez-vous vraiment déconnecter cette intégration ?",
    needIntegration: "Besoin d'une intégration manquante ?",
    contactUs: "Contactez-nous pour la développer",
    configure: "Configurer",
    settings: "Paramètres",
    status: "Statut",
    lastSync: "Dernière synchro",
    sync: "Synchroniser",
    syncingStatus: "Synchronisation...",
    connect: "Connecter",
    connecting: "Connexion...",
    disconnecting: "Déconnexion...",
    configureFirst: "Configurer d'abord",
    configureIntegration: "Configurer {{name}}",
    saveAndConnect: "Enregistrer et connecter",
    notConnected: "Non connecté",
    oauthAuth: "Authentification OAuth",
    credentials: "Identifiants",
    secureAuth: "✨ Autorisation sécurisée",
    oauthDescription: "Cliquez sur \"Connecter\" pour être redirigé vers {{name}} et autoriser l'accès.",
    oauthBenefits: {
      noExposure: "✓ Pas d'exposition d'identifiants",
      secure: "✓ Sécurisé et chiffré",
      revocable: "✓ Révocable à tout moment",
    },
    noCredentialsRequired: "Aucun identifiant supplémentaire requis.",
    testConnection: "Tester la connexion",
    connectionSuccessful: "Connexion réussie.",
    connectionError: "Erreur de connexion. Vérifiez les identifiants.",
    networkError: "Erreur réseau lors du test",
    invalidCredentials: "Identifiants invalides",
    noTenantSelected: "Aucun tenant sélectionné",
    processing: "Traitement...",
    reconnect: "Reconnecter",
    apiKeys: "Clés API",
    inDevelopment: "Page des intégrations en développement.",
    connectedLabel: "connectées",
    totalLabel: "intégrations",
    failedLabel: "avec erreur",
    clearSearch: "Effacer la recherche",
    available: "Disponibles",
    connectWhatsApp: "Connecter WhatsApp",
    showValue: "Afficher la valeur",
    hideValue: "Masquer la valeur",
    officialDocs: "Documentation officielle",

    woocommerce: {
      oauthRecommended: "OAuth (Recommandé)",
      apiKeysAlternative: "Clés API (Alternative)",
      oauthTitle: "Connexion avec OAuth (1 clic)",
      oauthDescription: "Vous avez seulement besoin de l'URL de votre boutique. Vous serez redirigé vers WooCommerce pour autoriser la connexion.",
      apiKeysTitle: "Connexion avec les clés API",
      apiKeysDescription: "Utilisez les clés API si votre boutique n'a pas de SSL ou si vous préférez cette méthode.",
      siteUrl: "URL de la boutique",
      consumerKey: "Clé client (Consumer Key)",
      consumerSecret: "Secret client (Consumer Secret)",
    },

    instructions: {
      woocommerce: {
        title: "Connecter WooCommerce - Deux méthodes",
        steps: "🔐 OAuth (Recommandé) :\n• Entrez l'URL de votre boutique\n• Cliquez sur \"Connecter\"\n• Vous serez redirigé vers WooCommerce pour autoriser\n\n🔑 Clés API (Alternative) :\n• Allez dans WooCommerce → Réglages → Avancé → API REST\n• Créez une clé API avec des permissions Lecture/Écriture\n• Copiez la Consumer Key et le Consumer Secret",
      },
      shopify: {
        title: "Comment connecter Shopify",
        steps: "1. Entrez le domaine de votre boutique (ex : votre-boutique.myshopify.com)\n2. Cliquez sur \"Connecter\"\n3. Vous serez redirigé vers Shopify\n4. Connectez-vous avec votre compte administrateur\n5. Cliquez sur \"Installer l'application\" pour autoriser\n6. Prêt ! Vous serez redirigé automatiquement",
      },
      'whatsapp-business': {
        title: "Comment obtenir les identifiants WhatsApp Business",
        steps: "1. Allez sur https://developers.facebook.com/apps/\n2. Créez une application de type \"Business\"\n3. Activez le produit \"WhatsApp\"\n4. Configurez un numéro de téléphone dans \"API Setup\"\n5. Copiez l'\"ID du numéro de téléphone\"\n6. Copiez le \"Jeton d'accès\" (temporaire)",
      },
      stripe: {
        title: "Comment obtenir votre clé Stripe",
        steps: "1. Allez sur votre tableau de bord Stripe\n2. Allez dans \"Développeurs\" → \"Clés API\"\n3. Copiez la \"Clé secrète\" (sk_live_... ou sk_test_...)\n4. Collez-la dans le champ ci-dessous",
      },
      paypal: {
        title: "Comment obtenir les identifiants PayPal",
        steps: "1. Allez sur https://developer.paypal.com/\n2. Connectez-vous avec votre compte PayPal\n3. Allez dans \"My Apps & Credentials\"\n4. Créez une application REST API\n5. Copiez le \"Client ID\" et le \"Secret\"",
      },
      mailchimp: {
        title: "Comment obtenir votre clé API Mailchimp",
        steps: "1. Allez sur votre compte Mailchimp\n2. Cliquez sur votre photo de profil → \"Compte\"\n3. Allez dans \"Extras\" → \"Claves API\"\n4. Créez une nouvelle clé API\n5. Copiez la clé et le préfixe du serveur (ex : us5)",
      },
      'google-calendar': {
        title: "Connecter Google Calendar",
        steps: "1. Cliquez sur \"Connecter\"\n2. Vous serez redirigé vers Google\n3. Connectez-vous avec votre compte Google\n4. Autorisez les permissions de Calendar\n5. Prêt ! Vos événements seront synchronisés",
      },
      gmail: {
        title: "Connecter Gmail",
        steps: "1. Cliquez sur \"Connecter\"\n2. Vous serez redirigé vers Google\n3. Connectez-vous avec votre compte Google\n4. Autorisez les permissions de lecture/écriture\n5. Prêt ! Vos e-mails seront synchronisés",
      },
    },

    helpLinks: {
      shopify: { shopDomain: "Comment trouver mon domaine ?" },
      woocommerce: {
        siteUrl: "Où se trouve mon URL ?",
        consumerKey: "Comment générer la Consumer Key ?",
        consumerSecret: "Comment générer le Consumer Secret ?",
      },
      'whatsapp-business': {
        phoneNumberId: "Comment obtenir l'ID du numéro de téléphone ?",
        accessToken: "Comment obtenir le jeton d'accès ?",
      },
      stripe: { secretKey: "Où se trouve ma Secret Key ?" },
      paypal: {
        clientId: "Où trouver le Client ID ?",
        secret: "Où trouver le Secret ?",
      },
      mailchimp: {
        apiKey: "Comment obtenir la clé API ?",
        server: "Qu'est-ce que le préfixe du serveur ?",
      },
      klaviyo: {
        publicKey: "Où se trouve ma Public Key ?",
        privateKey: "Où se trouve ma Private Key ?",
      },
      zendesk: {
        subdomain: "Quel est le sous-domaine ?",
        email: "Quel e-mail utiliser ?",
        apiToken: "Comment générer un jeton API ?",
      },
      livechat: {
        licenseId: "Où se trouve mon License ID ?",
        apiKey: "Comment obtenir la clé API ?",
      },
      prestashop: {
        url: "Quelle URL utiliser ?",
        apiToken: "Comment générer un jeton API ?",
      },
      cmi: {
        merchantId: "Contactez CMI pour obtenir votre Merchant ID",
        hmacKey: "Ils vous fourniront une clé HMAC",
      },
      zapier: { hookUrl: "Comment créer un webhook dans Zapier ?" },
    },
    categories: {
      all: "Toutes",
      messaging: "Messagerie",
      ecommerce: "eCommerce",
      crm: "CRM",
      productivity: "Productivité",
      payment: "Paiements",
      other: "Autres",
    },
  },

  settings: {
    title: "Paramètres",
    subtitle: "Configurez votre compte, votre entreprise et votre facturation.",

    tabs: {
      company: "Entreprise",
      privacy: "Confidentialité",
      payments: "Paiements",
      billing: "Facturation",
      plan: "Abonnement",
      employees: "Employés",
      business: "Activité",
    },

    company: {
      sectionTitle: "Détails de l'entreprise",
      panelLanguage: "Langue du panel",
      name: "Nom de l'entreprise",
      rc: "RC",
      ice: "ICE",
      phone: "Téléphone",
      email: "E-mail",
      address: "Adresse",
      website: "Site web",
      country: "Pays de l'activité",
    },

    privacy: {
      usersAccess: "Utilisateurs et accès",
      usersAccessHint: "Contrôlez qui peut accéder à ce compte.",
      inviteUser: "Inviter un utilisateur",
      invitePlaceholder: "email@exemple.com",
      role: "Rôle",
      invite: "Inviter",
      email: "E-mail",
      actions: "Actions",
      remove: "Retirer",
      empty: "Aucun utilisateur pour le moment.",
      security: "Sécurité",
      force2fa: "Forcer la 2FA",
      disabled: "Désactivé",
      requiredAdmins: "Obligatoire pour Admin/Owner",
      requiredAll: "Obligatoire pour tous",
      sessionExpiry: "Expiration de session",
      days7: "7 jours",
      days30: "30 jours",
      days90: "90 jours",
      resetPasswords: "Réinitialiser les mots de passe",
      sendReset: "Envoyer les e-mails de réinitialisation",
      recommended2fa: "Recommandé : forcer la 2FA au moins pour Admin/Owner.",
      loadingUser: "Chargement de l'utilisateur...",
      cannotIdentifyTenant: "Impossible d'identifier le tenant",
      changePassword: "Changer le mot de passe",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      allFieldsRequired: "Tous les champs sont obligatoires",
      passwordsDontMatch: "Les nouveaux mots de passe ne correspondent pas",
      passwordTooShort: "Le mot de passe doit faire au moins 6 caractères",
      passwordUpdated: "Mot de passe mis à jour avec succès !",
      noInvitePermission: "Vous n'avez pas l'autorisation d'inviter des membres.",
      upgradePlan: "Améliorez votre abonnement",
    },

    payments: {
      method: "Mode de paiement",
      openPortal: "Ouvrir le portail sécurisé",
      desc: "Gérez votre carte et vos factures via un portail sécurisé (PCI DSS) — ex : Stripe Customer Portal.",
      currentMethod: "Mode actuel",
      holder: "Titulaire",
      loadingTenant: "Chargement des informations du tenant...",
      errorOpeningPortal: "Erreur lors de l'ouverture du portail",
      noPortalUrl: "Aucune URL de portail reçue",
      noPaymentMethods: "Aucun mode de paiement configuré",
      default: "Par défaut",
      expires: "Expire",
      manageInStripe: "Gérer dans Stripe",
    },

    billing: {
      history: "Historique des factures",
      none: "Aucune facture pour le moment.",
      count: "Factures",
    },

    plan: {
      current: "Votre abonnement actuel",
      plan: "Plan",
      minutes: "Minutes utilisées (mois)",
      renewal: "Renouvellement",
      loadingUser: "Chargement de l'utilisateur...",
      noAuthenticatedUser: "Aucun utilisateur authentifié",
      userHasNoTenant: "L'utilisateur n'a pas de tenant assigné",
      cannotIdentifyTenant: "Impossible d'identifier le tenant",
      errorCreatingCheckout: "Erreur lors de la création du checkout",
      noCheckoutUrl: "Aucune URL de checkout reçue",
      errorOpeningPortal: "Erreur lors de l'ouverture du portail",
      noPortalUrl: "Aucune URL de portail reçue",
      subscriptionUpdated: "Abonnement mis à jour avec succès !",
      currentPlan: "Actuel",
      manage: "Gérer",
      price: "Prix",
      available: "Abonnements disponibles",
      select: "Sélectionner",
      noPlan: "Vous n'avez aucun abonnement actif.",
    },

    employees: {
      manage: "Gérer les employés",
      name: "Nom",
      position: "Poste",
      phone: "Téléphone",
      add: "Ajouter",
      actions: "Actions",
      delete: "Supprimer",
      empty: "Aucun employé pour le moment.",
    },

    business: {
      params: "Paramètres de l'activité",
      type: "Type d'activité (clé)",
      category: "Catégorie / Sous-type (clé)",
      timezone: "Fuseau horaire",
      tables: "Nombre de tables",
      capacity: "Capacité (personnes)",
      applyAll: "Appliquer à tous",
      hours: "Horaires",
      open: "Ouvert",
      opensAt: "Ouvre",
      closesAt: "Ferme",
    },
  },

  dow: {
    mon: "Lun",
    tue: "Mar",
    wed: "Mer",
    thu: "Jeu",
    fri: "Ven",
    sat: "Sam",
    sun: "Dim",
  },

  business: {
    type: {
      restaurant: "Restaurant",
      cafe: "Café",
      bar: "Bar / Nightlife",
      hotel: "Hôtel",
      spa: "Spa",
      clinic: "Clinique",
      salon: "Salon / Beauté",
      gym: "Salle de sport",
      retail: "Commerce / Boutique",
      ecommerce: "eCommerce",
      services: "Services",
      real_estate: "Immobilier",
      other: "Autre",
    },
  },

  ai: {
    title: "Assistant IA",
    settings: "Configuration de l'IA",
    context: "Contexte de l'entreprise",
    restaurantProfile: "Profil du restaurant",
    voiceAssistant: "Assistant vocal",
    fileUpload: "Téléchargement de fichiers",
    messages: "Conversations",
    training: "Entraînement",
    suggestions: "Suggestions",
    generate: "Générer",
    regenerating: "Régénération...",
    prompt: "Prompt",
    response: "Réponse",
    copy: "Copier",
    copied: "Copié",
    unblockAI: "Débloquer l'IA",
    blockAI: "Bloquer l'IA",
    blockedManually: "Bloqué manuellement",
  },

  restaurant: {
    editor: "Éditeur de restaurant",
    loading: "Chargement des données du restaurant...",
    readOnly: "Lecture seule",
    lastSaved: "Dernière sauvegarde",
    editMode: "Mode édition",
    preview: "Aperçu",
    profilePreview: "Aperçu du profil",
    saveChanges: "Enregistrer les modifications",
    notSpecified: "Non spécifié",
    cuisineType: "Type de cuisine",
    checkInPerson: "Consulter sur place",
    liveRoom: "Salle en direct",
    soon: "BIENTÔT",
    inRoom: "EN SALLE",
    newCustomer: "Nouveau client",
    assignTable: "Assigner une table",
    waitlist: "Liste d'attente",
    addToWaitlist: "Ajouter à l'attente",
    noFreeTables: "Pas de tables libres pour {{pax}} personnes",
    view: "vue",
    list: "Liste",
    map: "Carte",
    swipeHint: "Tables · glissez ← → pour changer d'état",
    upcoming: "À venir",
    noUpcomingBookings: "Aucune réservation à venir",
    tapToMarkArrival: "Tapez pour marquer l'arrivée",
    hotTables: "Tables chaudes",
    emptyList: "Liste vide",
    noActivity: "Aucune activité",
    table: "Table",
    general: "Général",
    location: "Emplacement",
    schedule: "Horaires",
    tables: "Tables",
    features: "Caractéristiques",
    celebrations: "Célébrations",
    menu: "Menu",
    policies: "Politiques",
    publish: "Publier",
    unpublish: "Dépublier",
    published: "Publié",
    draft: "Brouillon",
    capacity: "Capacité",
    combinable: "Combinable",
    zones: "Zones",

    status: {
      free: "Libre",
      reserved: "Réservée",
      occupied: "Occupée",
      cleaning: "Nettoyage",
    },

    errors: {
      cannotResolveTenant: "Impossible de résoudre le tenant actuel.",
      loginAgain: "Connectez-vous à nouveau et réessayez.",
    },

    generalSection: {
      title: "Informations générales",
      name: "Nom du restaurant",
      namePlaceholder: "Ex : Restaurant Le Petit Coin",
      phone: "Téléphone",
      phonePlaceholder: "+212 600 000000",
      email: "E-mail",
      emailPlaceholder: "info@restaurant.com",
      founded: "Année de fondation",
      foundedPlaceholder: "1998",
      capacity: "Capacité",
      capacityPlaceholder: "80",
      description: "Description",
      descriptionPlaceholder: "Décrivez le restaurant, son histoire et sa proposition...",
      social: "Réseaux sociaux",
      facebookPlaceholder: "facebook.com/...",
      instagramPlaceholder: "@utilisateur",
      xPlaceholder: "@utilisateur",
      classification: "Classification",
      cuisine: "Type de cuisine",
      dietary: "Options diététiques",
      ambience: "Ambiance",
      specialties: "Spécialités du chef",
      certifications: "Certifications",
      owner: "Propriétaire / Chef",
      ownerName: "Nom",
      ownerNamePlaceholder: "Ex : Jean Dupont",
      ownerBio: "Biographie",
      ownerBioPlaceholder: "Histoire du chef...",
      funFacts: "Anecdotes et curiosités",
      funFactsPlaceholder: "Ex : La recette secrète est dans la famille depuis 50 ans...",
    },

    certifications: {
      halal: "Halal",
      organic: "Bio",
      sustainable: "Durable",
      michelin: "Michelin",
      glutenFree: "Sans gluten",
      vegan: "Végan",
      vegetarian: "Végétarien",
    },

    schedule: {
      venueHours: "Horaires de l'établissement",
      copyMonday: "Copier le lundi pour tous",
      closed: "Fermé",
      morning: "Matin / Midi",
      evening: "Après-midi / Soir",
      notApplicable: "Non applicable",
      kitchenHours: "Horaires de cuisine",
      closedKitchen: "Fermée",
      mealServices: "Services de repas",
      breakfast: "Petit-déjeuner",
      brunch: "Brunch",
      lunch: "Déjeuner",
      dinner: "Dîner",
      lateNight: "Fin de soirée",
      twoDinnerShifts: "Deux services de dîner",
      firstShift: "1er service",
      secondShift: "2ème service",
      holidays: "Jours fériés et fermetures spéciales",
      noHolidays: "Pas de jours fériés configurés",
      holidayReason: "Motif (Noël, Ramadan...)",
      seasonalHours: "Horaires saisonniers",
      summer: "Été",
      winter: "Hiver",
      ramadan: "Ramadan",
    },

    features: {
      venueFeatures: "Caractéristiques de l'établissement",
      accessibility: "Accessibilité",
      services: "Services",
      paymentMethods: "Modes de paiement",
      soundEnvironment: "Environnement sonore",
      hasBackgroundMusic: "Musique d'ambiance",
      mainGenres: "Genres principaux",
      volumeLevel: "Niveau sonore habituel",
      liveMusic: "Musique en direct",
      frequency: "Fréquence",
      liveMusicTypes: "Types de musique en direct",
      approximateSchedule: "Horaires approximatifs",
      schedulePlaceholder: "Ex : vendredi et samedi 20:00-23:00",
      atmosphere: "Ambiance et climat",
      roomTemperature: "Température ambiante",
      climateSystem: "Système de climatisation",
      lighting: "Ambiance lumineuse",
      outdoorSeating: "Terrasse extérieure",
      heatedTerrace: "Terrasse chauffée",
      fans: "Ventilateurs",
      entertainment: "Divertissement",
      sustainability: "Durabilité",
      technology: "Technologie",

      volumeLevels: {
        quiet: "Bas / conversation",
        medium: "Moyen",
        loud: "Élevé",
      },
      frequencies: {
        daily: "Quotidien",
        weekends: "Week-ends",
        weekly: "Une fois par semaine",
        occasional: "Occasionnel / événements spéciaux",
      },
      temperature: {
        cold: "Froid (clim forte)",
        comfortable: "Confortable (21-23°C)",
        warm: "Chaud (chauffage)",
        variable: "Variable selon la zone",
      },
      climateSystem: {
        ac: "Climatisation",
        heating: "Chauffage",
        both: "Les deux",
        natural: "Ventilation naturelle uniquement",
      },
      lighting: {
        bright: "Éclairage vif",
        ambient: "Lumière d'ambiance",
        dim: "Lumière tamisée / romantique",
        adjustable: "Réglable par zone",
      },
      techItems: {
        qrMenus: "Menus QR",
        ownApp: "App propre",
        nfcPayment: "Paiements NFC",
        digitalWaitlist: "Liste d'attente digitale",
      },
    },

    celebrations: {
      title: "Célébrations et événements spéciaux",
      birthdayCake: "Gâteau d'anniversaire",
      price: "Prix",
      numberOfPeople: "Nombre de personnes",
      specialPackages: "Forfaits spéciaux",
      addPackage: "Ajouter un forfait",
      noPackages: "Aucun forfait configuré",
      packageName: "Nom du forfait",
      packageDescription: "Description du forfait",
      description: "Description",
      options: {
        birthday: "Anniversaire",
        anniversary: "Anniversaire de mariage",
        engagement: "Demande en mariage",
        business: "Repas d'affaires",
        graduation: "Remise de diplômes",
        other: "Autres",
      },
    },

    menu: {
      importWithAI: "Importer le menu avec l'IA",
      importDescription: "Importez votre carte depuis un PDF, une photo, Word ou Excel. L'IA extraira automatiquement les catégories, les plats, les prix et les allergènes.",
      supportedFormats: "Formats supportés : PDF, JPG, PNG, DOCX, XLSX · Max. 10 Mo",
      processing: "Traitement...",
      importMenu: "Importer la carte",
      ocrHint: "L'importation OCR détectera la langue automatiquement et l'IA normalisera les noms et les prix.",
      categories: "Catégories",
      newCategory: "Nouvelle catégorie",
      editCategory: "Modifier la catégorie",
      noCategories: "Aucune catégorie. Créez-en une ou importez votre carte.",
      categoryNamePlaceholder: "Ex : Entrées, Viandes, Desserts...",
      categoryDescriptionPlaceholder: "Description facultative de la catégorie",
      categoryUpdated: "Catégorie mise à jour",
      categoryCreated: "Catégorie créée",
      categoryDeleted: "Catégorie supprimée",
      confirmDeleteCategory: "Supprimer cette catégorie et tous ses plats ?",
      dishes: "Plats",
      newDish: "Nouveau plat",
      editDish: "Modifier le plat",
      loadingDishes: "Chargement des plats...",
      noDishes: "Aucun plat dans cette catégorie.",
      dishName: "Nom du plat",
      dishNamePlaceholder: "Ex : Salade César",
      dishDescriptionPlaceholder: "Ingrédients principaux, préparation...",
      category: "Catégorie",
      noCategory: "Sans catégorie",
      preparationTime: "Préparation (min)",
      calories: "Calories (kcal)",
      dietaryOptions: "Options diététiques",
      dishUpdated: "Plat mis à jour",
      dishCreated: "Plat créé",
      dishDeleted: "Plat supprimé",
      confirmDeleteDish: "Supprimer ce plat ?",
      processingError: "Erreur lors du traitement du fichier",
      importError: "Erreur lors de l'importation",
      menuImported: "Menu importé : {{categories}} catégories, {{items}} plats",
      unnamed: "Sans nom",

      dietary: {
        vegetarian: "Végétarien",
        vegan: "Végan",
        glutenFree: "Sans gluten",
        spicy: "Épicé",
      },

      allergens: {
        title: "Allergènes",
        gluten: "Gluten",
        crustaceans: "Crustacés",
        eggs: "Œufs",
        fish: "Poisson",
        peanuts: "Arachides",
        soy: "Soja",
        dairy: "Produits laitiers",
        nuts: "Fruits à coque",
        celery: "Céleri",
        mustard: "Moutarde",
        sesame: "Sésame",
        sulfites: "Sulfites",
        lupin: "Lupin",
        mollusks: "Mollusques",
      },
    },

    policies: {
      bookingPolicies: "Politiques de réservation",
      cancellationHours: "Annulation — heures avant",
      noShowPenalty: "Pénalité no-show (%)",
      deposit: "Acompte",
      perPerson: "Par personne",
      tableHoldTime: "Rétention de table (min)",
      restrictions: "Restrictions",
      minorsAllowed: "Mineurs autorisés",
      minorsAccompanied: "Mineurs accompagnés",
      adultsOnly: "Adultes uniquement (+18)",
      petsAllowed: "Animaux autorisés",
      serviceAnimals: "Animaux d'assistance",
      smokingArea: "Zone fumeurs",
      smokingTerrace: "Terrasse fumeurs",
      dressCode: "Code vestimentaire",
      groupsWelcome: "Groupes bienvenus",
      dressCodeTitle: "Code vestimentaire",
      dressCodeType: "Type de code",
      noDressCode: "Pas de code spécifique",
      casual: "Décontracté / Informel",
      smartCasual: "Smart Casual",
      elegante: "Élégant",
      formal: "Formel (costume)",
      traditional: "Traditionnel",
      dressCodePlaceholder: "Ex : Tenue élégante exigée, veste pour les messieurs...",
      groupPolicies: "Politiques de groupe",
      minGroupSize: "Taille min. du groupe",
      advanceNotice: "Anticipation requise (heures)",
      specialGroupPolicy: "Politique spéciale pour les groupes",
      specialGroupPolicyPlaceholder: "Ex : Menu fixe obligatoire, acompte de 30%...",
      children: "Enfants",
      kidsMenu: "Menu enfant",
      notAvailable: "Non disponible",
      available: "Disponible",
      customizable: "Menu personnalisable",
      childAgeLimit: "Âge limite enfant (ans)",
      highChairs: "Chaises hautes disponibles",
      changingTable: "Table à langer dans les toilettes",
      playArea: "Aire de jeux",
      pets: "Animaux",
      petPolicy: "Politique relative aux animaux",
      noPets: "Animaux non admis",
      serviceAnimalsOnly: "Uniquement animaux d'assistance",
      teraceOnly: "Uniquement en terrasse",
      allAllowed: "Admis dans tout l'établissement",
      waterBowl: "Bol d'eau disponible",
      treats: "Friandises pour animaux",
      health: "Santé",
      masksRequired: "Masque obligatoire",
      vaccinationRequired: "Vaccination obligatoire",
      maxCapacity: "Capacité maximale",
      capacityPlaceholder: "Ex : 50",
      inclusivity: "Inclusivité",
      lgbtqFriendly: "LGBTQ+ friendly",
      accessibleAll: "Accessible à tous",
      diversityStatement: "Déclaration de diversité",
      diversityPlaceholder: "Ex : Nous accueillons tout le monde quel que soit...",
      legalTerms: "Conditions juridiques",
      privacyPolicy: "Politique de confidentialité (URL ou texte)",
      privacyPlaceholder: "https://... ou texte de la politique",
      termsAndConditions: "Conditions générales",
      termsPlaceholder: "Conditions générales de réservation...",
      gdprCompliant: "Conforme RGPD",
    },
  },

  automations: {
    title: "Automatisations",
    subtitle: "Connectez des événements à des actions automatiques sans code.",
    newAutomation: "Nouvelle automatisation",
    new: "Nouvelle",
    active: "Active",
    inactive: "Inactive",
    test: "Tester",
    testing: "Test en cours...",
    testSuccess: "Test exécuté avec succès ✅",
    testError: "Erreur lors du test",
    noAutomations: "Aucune automatisation",
    noAutomationsDesc: "Créez votre première automatisation ou utilisez un modèle pour commencer rapidement.",
    viewTemplates: "Voir les modèles",
    createFromScratch: "Créer de zéro",
    generateWithAI: "Générer avec l'IA",
    use: "Utiliser",
    deleteTitle: "Supprimer l'automatisation ?",
    deleteConfirm: "Cette action est irréversible.",
    when: "QUAND",
    before: "avant",
    delay: "délai",
    addStep: "Ajouter une étape",
    selectTrigger: "Sélectionnez l'événement qui déclenche cette automatisation :",
    whenThisHappens: "Quand ceci se produit...",
    executeTheseActions: "Exécuter ces actions :",
    requiresTimeConfig: "Nécessite une configuration temporelle",
    willSend: "Sera envoyé",
    beforeBooking: "avant la réservation",
    ofWait: "d'attente",
    automationName: "Nom de l'automatisation",
    clickToInsert: "Cliquez sur une variable pour l'insérer :",
    example: "Exemple",

    categories: {
      ecommerce: "E-commerce",
      bookings: "Réservations",
      messages: "Messages",
      advanced: "Avancé",
      control: "Contrôle",
    },

    triggers: {
      newOrderWoo: "Nouvelle commande (WooCommerce)",
      newOrderWooDesc: "Se déclenche à la réception d'une nouvelle commande sur votre boutique.",
      orderUpdatedWoo: "Commande mise à jour (WooCommerce)",
      orderUpdatedWooDesc: "Se déclenche lors du changement de statut d'une commande existante.",
      bookingReminder: "Rappel de réservation",
      bookingReminderDesc: "Envoie un avis au client avant sa réservation. Vous choisissez combien de temps avant.",
      newBookingConfirmed: "Nouvelle réservation confirmée",
      newBookingConfirmedDesc: "Se déclenche lors de la création d'une nouvelle réservation dans le système.",
      newWhatsAppMessage: "Nouveau message WhatsApp",
      newWhatsAppMessageDesc: "Se déclenche lorsqu'un client envoie un message via WhatsApp.",
      incomingWebhook: "Webhook entrant",
      incomingWebhookDesc: "Se déclenche lorsque vous recevez une requête HTTP externe.",
    },

    variables: {
      orderId: "Numéro de commande",
      orderTotal: "Total de la commande",
      orderStatus: "Statut de la commande",
      newStatus: "Nouveau statut",
      customerName: "Nom du client",
      customerPhone: "Téléphone du client",
      customerEmail: "E-mail du client",
      productNames: "Produits de la commande",
      phone: "Téléphone",
      bookingDate: "Date de la réservation",
      bookingTime: "Heure de la réservation",
      time: "Heure",
      people: "Nombre de personnes",
      reference: "Référence",
      messageText: "Texte du message",
      webhookData: "Données du webhook",
    },

    fields: {
      sendBefore: "Envoyer avec quel préavis",
      timeUnit: "Unité de temps",
      templateName: "Nom du modèle",
      language: "Langue",
      jsonBody: "Corps JSON (optionnel)",
      wait: "Attendre",
      unit: "Unité",
    },

    units: {
      minutesBefore: "Minutes avant",
      hoursBefore: "Heures avant",
      daysBefore: "Jours avant",
      minutes: "Minutes",
      hours: "Heures",
      days: "Jours",
      short: {
        minutes: "min",
        hours: "h",
        days: "j",
      },
    },

    languages: {
      spanish: "Espagnol",
      french: "Français",
      english: "Anglais",
      arabic: "Arabe",
    },

    actions: {
      sendWhatsApp: "Envoyer un message WhatsApp",
      sendWhatsAppDesc: "Envoie un message texte via WhatsApp au client.",
      sendTemplate: "Envoyer un modèle WhatsApp",
      sendTemplateDesc: "Envoie un modèle officiel approuvé par Meta.",
      callExternalUrl: "Appeler une URL externe",
      callExternalUrlDesc: "Effectue une requête HTTP POST vers un endpoint externe.",
      wait: "Attendre un certain temps",
      waitDesc: "Met en pause pendant X minutes/heures/jours avant l'action suivante",
    },

    placeholders: {
      example2: "Ex : 2",
      example7: "Ex : 7",
      messageExample: "Ex : Bonjour {{customer_name}} ! Nous vous rappelons votre réservation du {{booking_date}} à {{booking_time}} ✅",
    },

    templates: {
      title: "Modèles d'automatisation",
      orderConfirmation: "Confirmation de commande",
      orderConfirmationDesc: "À la réception d'une nouvelle commande, envoie une confirmation automatique par WhatsApp.",
      reminder2h: "Rappel de réservation 2h avant",
      reminder2hDesc: "Avertit le client 2 heures avant sa réservation.",
      reminder1d: "Rappel de réservation 1 jour avant",
      reminder1dDesc: "Avertit le client la veille de sa réservation.",
      orderShipped: "Commande expédiée → avis WhatsApp",
      orderShippedDesc: "Lorsqu'une commande passe à \"en cours\", informe le client.",
      review7d: "Avis 7 jours après la commande",
      review7dDesc: "Sollicite une évaluation une semaine après l'achat.",
    },

    templateMessages: {
      orderConfirmation: "Bonjour {{customer_name}} ! 🎉\n\nNous avons bien reçu votre commande {{order_id}}.\n\n🛍️ Produits : {{product_names}}\n💰 Total : {{order_total}}\n\nNous vous préviendrons lors de l'expédition. Merci pour votre achat !",
      reminder2h: "Bonjour {{customer_name}} ! 👋\n\nNous vous rappelons votre réservation d'aujourd'hui à *{{booking_time}}* pour {{people}} personnes.\n\nSi vous avez besoin de modifier quoi que ce soit, répondez à ce message.\n\nÀ bientôt ! 🍽️",
      reminder1d: "Bonjour {{customer_name}} ! 😊\n\nNous vous rappelons que demain *{{booking_date}}* vous avez une réservation à *{{booking_time}}* pour {{people}} personnes.\n\nRéf : {{reference}}\n\nBesoin d'annuler ou de modifier ? Écrivez-nous ici.",
      orderShipped: "Bonjour {{customer_name}} ! 📦\n\nVotre commande {{order_id}} est en cours de préparation.\nVous recevrez bientôt plus d'informations sur l'expédition.",
      review7d: "Bonjour {{customer_name}} ! ⭐\n\nNous espérons que vous profitez bien de votre commande {{order_id}}.\n\nPourriez-vous nous laisser une évaluation ? Votre avis nous aide beaucoup. Merci !",
    },

    errors: {
      selectTrigger: "Sélectionnez un déclencheur",
      addAtLeastOneAction: "Ajoutez au moins une action (pas seulement un délai)",
      configureReminder: "Configurez le préavis du rappel (quantité et unité)",
      saveFailed: "Erreur lors de l'enregistrement",
      unknownError: "Erreur inconnue",
      saveFirst: "Enregistrez d'abord l'automatisation",
    },

    aiAssistant: "Assistant IA",
    aiDescription: "Décrivez votre automatisation en langage naturel",
    aiWhatToAutomate: "Que voulez-vous automatiser ?",
    aiPlaceholder: "Ex : Envoyer un WhatsApp au client 7 jours après sa commande pour lui demander un avis...",
    aiEnterHint: "Appuyez sur Entrée pour générer · Maj+Entrée pour une nouvelle ligne",
    aiExampleRequests: "Exemples de demandes",
    aiGenerating: "Génération...",
    aiProcessing: "Mistral traite votre demande",
    aiGenerated: "Automatisation générée",
    aiReviewHint: "Révisez le message généré et ajustez-le avant d'activer l'automatisation.",
    aiNewRequest: "Nouvelle demande",
    aiUseThis: "Utiliser cette automatisation",
    aiGenerate: "Générer",

    aiSuggestions: {
      confirmation: "Envoyer un WhatsApp de confirmation lors d'une nouvelle commande",
      reminder2h: "Rappeler la réservation au client 2 heures avant",
      review7d: "Demander un avis 7 jours après la commande",
      processing: "Prévenir le client quand sa commande passe à \"en cours\"",
      welcome: "Message de bienvenue lors d'un nouveau message WhatsApp",
      reminder1d: "Rappel de réservation la veille",
    },

    aiErrors: {
      generationFailed: "Erreur lors de la génération de l'automatisation",
      connectionError: "Erreur de connexion. Vérifiez que le serveur est actif.",
    },

    waitDays: "Attendre {{count}} jour(s)",
    waitHours: "Attendre {{count}} heure(s)",
    waitMinutes: "Attendre {{count}} minute(s)",
  },

  freelance: {
    manager: "Gestionnaire freelance",
    profile: "Mon profil",
    availability: "Disponibilité",
    services: "Services",
    media: "Médias",
    schedule: "Horaires",
    general: "Général",
    physicalCharacteristics: "Caractéristiques physiques",
    chat: "Chat",
    preview: "Aperçu",
  },


  products: {
    title: "Produits",
    all: "Tous les produits",
    active: "Actifs",
    inactive: "Inactifs",
    outOfStock: "Rupture de stock",
    lowStock: "Stock faible",
    categories: "Catégories",
    price: "Prix",
    stock: "Stock",
    sku: "SKU",
    variants: "Variantes",
    attributes: "Attributs",
    description: "Description",
    images: "Images",
    addProduct: "Ajouter un produit",
    editProduct: "Modifier le produit",
  },

  billing: {
    title: "Facturation",
    invoices: "Factures",
    paymentMethods: "Modes de paiement",
    subscription: "Abonnement",
    currentPlan: "Abonnement actuel",
    changePlan: "Changer d'abonnement",
    cancelPlan: "Résilier l'abonnement",
    billingHistory: "Historique de facturation",
    downloadInvoice: "Télécharger la facture",
    amount: "Montant",
    date: "Date",
    status: "Statut",
    paid: "Payé",
    unpaid: "Impayé",
    overdue: "En retard",
  },

  support: {
    contactSupport: "Contacter le support",
    submitTicket: "Envoyer un ticket",
    ticketHistory: "Historique des tickets",
    faq: "FAQ",
    chat: "Chat en direct",
    email: "E-mail support",
    phone: "Téléphone support",
    priority: "Priorité",
    low: "Basse",
    medium: "Moyenne",
    high: "Haute",
    urgent: "Urgente",
    subject: "Objet",
    message: "Message",
    attachments: "Pièces jointes",
    submit: "Envoyer",
    submitted: "Envoyé",
  },

  notifications: {
    title: "Notifications",
    all: "Toutes",
    unread: "Non lues",
    markAllRead: "Tout marquer comme lu",
    clearAll: "Tout effacer",
    empty: "Aucune notification",
    settings: "Paramètres des notifications",
    emailNotifications: "Notifications par e-mail",
    pushNotifications: "Notifications push",
    sound: "Son",
    desktop: "Bureau",
    mobile: "Mobile",
  },

  calls: {
    title: "Appels",
    calls: "Appels",
    searchPlaceholder: "Rechercher par ID, numéro ou intent...",
    reset: "Réinitialiser",
    intent: "Intention",
    table: {
      id: "ID",
      from: "De",
      to: "À",
      duration: "Durée",
      toLabel: "À",
    },
    intents: {
      booking: "Réservation",
      menu: "Menu",
      complaint: "Réclamation",
      schedule: "Horaires",
      location: "Emplacement",
      payment: "Paiement",
      menuLetter: "Carte",
    },
    status: {
      ok: "OK",
      ongoing: "En cours",
      failed: "Échoué",
    },
    comingSoon: {
      title: "Appels avec IA",
      description: "Cette section sera disponible prochainement. Vous pourrez voir, filtrer et analyser tous vos appels gérés par l'IA.",
      badge: "Bientôt",
    },
    call: "Appel",
    detailSubtitle: "Résumé et transcription de l'appel.",
    backToList: "Retour aux appels",
    participants: "Participants",
    audio: "Audio",
    download: "Télécharger",
    noAudio: "Aucun audio disponible pour cet appel.",
    transcript: "Transcription",
    assistant: "Assistant",
    user: "Utilisateur",
    metadata: "Métadonnées",
    processedMeta: "Traité STT→GPT→TTS : ~620ms",
    audioQuality: "Qualité audio : 8k μ-law",
    detectedLanguage: "Langue détectée : fr/ar",
  },

  errors: {
    somethingWentWrong: "Une erreur est survenue",
    tryAgain: "Réessayer",
    pageNotFound: "Page non trouvée",
    unauthorized: "Non autorisé",
    forbidden: "Accès interdit",
    serverError: "Erreur serveur",
    networkError: "Erreur réseau",
    validationError: "Erreur de validation",
    required: "Ce champ est obligatoire",
    invalidEmail: "E-mail invalide",
    invalidPhone: "Téléphone invalide",
    minLength: "Minimum {{min}} caractères",
    maxLength: "Maximum {{max}} caractères",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    tenantNotFound: "Impossible d'identifier le tenant. Veuillez recharger.",
  },
} as const;

export default fr;
